import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface User {
  id: string;
  emailAddress: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  cnic?: string;
  isActive: boolean;
  isVerified: boolean;
  role: string;
  createdAt: string;
  updatedAt: string;
  isProfileComplete?: boolean;
  technology?: {
    id: number;
    uuid: string;
    name: string;
  };
}

interface UserState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  expireTimer: string | number;
  resetToken: string | null;
}

const initialState: UserState = {
  user: null,
  token: null,
  isAuthenticated: false,
  expireTimer: '',
  resetToken: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },
    setExpireTimer: (state, action: PayloadAction<string>) => {
      state.expireTimer = action.payload;
    },
    setResetToken: (state, action: PayloadAction<string>) => {
      state.resetToken = action.payload;
    },
    initializeUser: (state, action: PayloadAction<{ user: User | null; token: string | null }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = !!action.payload.token;
    },
    updateProfileComplete: (state, action: PayloadAction<boolean>) => {
      if (state.user) {
        state.user.isProfileComplete = action.payload;
      }
    }
  },
});

export const { setUser, clearUser, setExpireTimer, setResetToken, initializeUser, updateProfileComplete } = userSlice.actions;
export default userSlice.reducer; 